/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import ZoneControl from 'solis/logic/board/zone/control';

import TimelineEvent from 'solis/logic/board/zone/timeline/event';


export default class StabilizeEvent extends TimelineEvent
{
  constructor (zone)
  {
    super(zone);

    this.user = null;
    this.value = null;
  }


  findNextDate (startDate)
  {
    for (const entry of new ZoneControl(this.zone).getUsers())
    {
      if (this.setEarlierDate(entry.getStabilizeDate(startDate)))
      {
        this.user  = entry.user;
        this.value = entry.getEquilibrium(startDate);
      }
    }
  }


  getLabel ()
  {
    return `${this.getUserName(this.user)} control stabilizes`;
  }


};
